import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'

import { ReactOfferElementsProps } from './types'
import { offerElementsClasses } from '../../constants'
import { getLocalStorage } from '../../utils/local-storage-util'
import { getAttributeValue, hasCFConditionals } from '../../utils/rule-builder-util'
import { getSpacing } from '../../utils/spacing-util'
import ReactList, { ListType } from '../ReactList'
import ReactText from '../ReactText'
import IsInEditorText from '../shared/IsInEditorText'
import './ReactOfferElements.scss'

const ReactOfferElements = (props: ReactOfferElementsProps) => {
  const {
    isInEditor = false,
    elements = {},
    id,
    index,
    ruleExpression = '',
    tokenProperties,
    top = false,
    left = false,
    right = false,
    bottom = false
  } = props

  const activeModalIndex = getLocalStorage('activeModalIndex')
  const offerIndex = activeModalIndex ?? index
  const offers = useFlexOffers(ruleExpression)
  const getValue = (attribute: any, propertyName?: string) => {
    const hasJsonAttribute = hasCFConditionals(attribute)
    if (hasJsonAttribute) {
      const jsonAttribute = (elements as any)?.[`${propertyName}_json`]
      return getAttributeValue(jsonAttribute, offers, offerIndex, tokenProperties, propertyName, hasJsonAttribute)
    }
    return getAttributeValue(attribute, offers, offerIndex, tokenProperties, propertyName)
  }
  const {
    heading = { value: '' },
    headingUnit = { value: '' },
    eyebrow = { value: '', title: '' },
    bulletPoints = { value: '' },
    additionalNote = { value: '' },
    description = { value: '' }
  } = elements
  const eyebrowValue = getValue(eyebrow, 'eyebrow')
  const headingValue = getValue(heading, 'heading')
  const headingUnitValue = getValue(headingUnit, 'headingUnit')
  const additionalNoteValue = getValue(additionalNote, 'additionalNote')
  const descriptionValue = getValue(description, 'description')

  return (
    <>
      {IsInEditorText(isInEditor, 'React Offer Elements')}
      <div
        data-testid={`react-offer-elements`}
        className={`react-offer-elements ${getSpacing(top, right, bottom, left, true)}`}
        id={id}
      >
        {headingValue && (
          <div className={offerElementsClasses.heading}>
            {<ReactText className={offerElementsClasses.headingValue} text={headingValue} isParsed />}
            {headingUnitValue && <ReactText className={offerElementsClasses.headingUnit} text={headingUnitValue} isParsed />}
          </div>
        )}
        {eyebrowValue && <ReactText className={offerElementsClasses.eyebrow} text={eyebrowValue} isParsed />}
        {additionalNoteValue && (
          <ReactText className={offerElementsClasses.additionalNote} text={additionalNoteValue} isParsed />
        )}
        {descriptionValue && <ReactText className={offerElementsClasses.description} text={descriptionValue} isParsed />}
        {bulletPoints.value.length > 0 && (
          <ReactList
            listFrom={ListType.customList}
            elements={elements}
            ruleExpression={ruleExpression}
            index={offerIndex}
            tokenProperties={tokenProperties}
          />
        )}
      </div>
    </>
  )
}
export default ReactOfferElements
